import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import moment from "moment";
import "../../../modules/global";

export class RecentRegistrations extends Component {
  render() {
    const registrations = this.props.items.map((hash, index) => {
      return (
        <tr key={index} className="bg-white shadow border">
          <td className="p-3">{hash.name}</td>
          <td className="p-3">{hash.phone_number}</td>
          <td className="p-3">
            {hash.booked_datetime
              ? moment(hash.booked_datetime).format("YYYY-MM-DD HH:mm")
              : hash.booked_date}
          </td>
          <td>
            {hash.date_done ? moment(hash.date_done).format("YYYY-MM-DD") : ""}
          </td>
          <td className="p-3">{hash.caring_store_name}</td>

          <td className="p-3">
            <NavLink
              to={`/admin/search-customer?phone_number=${hash.phone_number}`}
            >
              View
            </NavLink>
          </td>
        </tr>
      );
    });

    return (
      <table id="dashboard-cards-table" className="w-100">
        <thead className="">
          <tr>
            {[
              "Name",
              "Phone Number",
              "Booking Date",
              "Completion Date",
              "Branch Name",
              "Actions",
            ].map((name, index) => {
              return (
                <th key={"table-header-" + name} className="px-3">
                  {name}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>{registrations}</tbody>
      </table>
    );
  }
}
